/* eslint-disable vue/require-v-for-key */
<template>
  <div>
    <v-card class="pa-2 ma-4 secondary--text text-subtitle-1 pa-4">
      <div>
        This page is used for administrative management of the
        storage system of this device. Please use with caution.
      </div>
      <v-btn
        :disabled="!isManager() && !isAdmin()"
        color="secondary"
        @click="confirmClearLocalStorage()"
        class="mt-3"
      >
        <v-icon>mdi-database</v-icon>
        <span>Clear Local Storage</span>
      </v-btn>
    </v-card>
    <v-card class="mx-4 pl-6 text-subtitle-1 d-flex my-auto">
      <div class="mt-3">
        Device Name: {{deviceName}}
      </div>
      <v-spacer />
      <v-btn class="ma-1"
        :disabled="!isManager() && !isAdmin()"
        color="primary"
        @click="showDeviceNameDialog = true"
      >
        <v-icon>mdi-pencil</v-icon>
        <span>Edit</span>
      </v-btn>
    </v-card>
    <v-expansion-panels class="px-4" v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header>Archived Egg Groups ({{this.archivedEggGroups.length}})</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="primary--text">* Archived Egg Groups older than 14 days are automatically deleted.</div>
          <v-text-field v-model="searchEggGroupArchive" clearable label="Search" />
          <div class="d-flex flex-wrap my-auto">
            <div v-if="archivedEggGroups.length == 0" class="text-subtitle-2">No Archived Egg Groups exist.</div>
            <v-card width="260px" 
              class="mr-2 mb-2" 
              outlined 
              v-for="(group,gndx) in filteredArchiveEggGroups" 
              :key="group.groupName + group.date">
              <v-card-title class="text-subtitle-2">
                  <div style="cursor: pointer" @click="toggleGroupDetail(showGroupDetail.egg, gndx)">
                    <b class="mr-2">{{group.groupName }}</b>
                    <v-icon v-if="showGroupDetail.egg[gndx]">mdi-chevron-up</v-icon>
                    <v-icon v-else>mdi-chevron-down</v-icon>
                  </div>
                  <div v-show="showGroupDetail.egg[gndx]">
                    <div v-for="action in sortGroupActionDates(group)" :key="action.type" class="ml-2">
                      <div v-if="action.date != null">
                        <v-icon class="px-0 pb-1 mr-2">{{ action.icon }}</v-icon>
                        <span class="pb-0">{{ formatDate(action.date) }}</span>
                      </div>
                    </div>
                  </div>
              </v-card-title>
              <div class="px-4">
                <v-btn
                  color="success"
                  class="my-2"
                  @click="showViewEggDialog(group)"
                >
                  <v-icon>mdi-eye-outline</v-icon><div class="text-subtitle-2"></div>
                </v-btn>
                <v-btn
                  :disabled="!isManager(group.farm) && !isAdmin()"
                  color="primary" 
                  class="my-2 mx-2" 
                  @click="confirmRestoreEggGroup(group)"
                >
                  <v-icon>mdi-file-restore-outline</v-icon>
                </v-btn>
                <v-btn
                  :disabled="!isManager(group.farm) && !isAdmin()"
                  color="secondary"
                  class="my-2"
                  @click="confirmDeleteEggGroup(group)"
                >
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </div>
            </v-card>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>Archived Vision Groups ({{this.archivedVisionGroups.length}})</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="primary--text">* Archived Vision Groups older than 14 days are automatically deleted.</div>
          <v-text-field v-model="searchVisionGroupArchive" clearable label="Search" />
          <div class="d-flex flex-wrap my-auto">
            <div v-if="archivedVisionGroups.length == 0" class="text-subtitle-2">No Archived Vision Groups exist.</div>
            <v-card width="260px" 
              class="mr-2 mb-2" 
              outlined 
              v-for="(group,gndx) in filteredArchiveVisionGroups" 
              :key="group.groupName + group.date">
              <v-card-title class="text-subtitle-2">
                  <div style="cursor: pointer" @click="toggleGroupDetail(showGroupDetail.vision, gndx)">
                    <b class="mr-2">{{group.groupName }}</b>
                    <v-icon v-if="showGroupDetail.vision[gndx]">mdi-chevron-up</v-icon>
                    <v-icon v-else>mdi-chevron-down</v-icon>
                  </div>
                  <div v-show="showGroupDetail.vision[gndx]">
                    <div v-for="action in sortGroupActionDates(group)" :key="action.type" class="ml-2">
                      <div v-if="action.date != null">
                        <v-icon class="px-0 pb-1 mr-2">{{ action.icon }}</v-icon>
                        <span class="pb-0">{{ formatDate(action.date) }}</span>
                      </div>
                    </div>
                  </div>
              </v-card-title>
              <div class="px-4">
                <v-btn
                  color="success"
                  class="my-2"
                  @click="showViewVisionDialog(group)"
                >
                  <v-icon>mdi-eye-outline</v-icon><div class="text-subtitle-2"></div>
                </v-btn>
                <v-btn
                  :disabled="!isManager(group.farm) && !isAdmin()"
                  color="primary" 
                  class="my-2 mx-2" 
                  @click="confirmRestoreVisionGroup(group)"
                >
                  <v-icon>mdi-file-restore-outline</v-icon>
                </v-btn>
                <v-btn
                  :disabled="!isManager(group.farm) && !isAdmin()"
                  color="secondary"
                  class="my-2"
                  @click="confirmDeleteVisionGroup(group)"
                >
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </div>
            </v-card>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
 
    <v-dialog v-model="clearLocalStorageDialog" persistent max-width="350">
      <v-card class="pb-2" color="cardbackground">
        <v-card-title class="text-h5">Clear Local Storage</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="3">
              <v-icon x-large color="secondary">mdi-alert-outline</v-icon>
            </v-col>
            <v-col cols="9">
              Clearing local storage will delete all Egg Picker data on your device.
              Are you sure you want to do this?

              WARNING: Do not do this is active Egg Vision data exists. Locally stored files will not be deleted and will lose tracking.
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" class="white--text" @click="clearLocalStorage()">Yes</v-btn>
          <v-btn color="secondary" @click="clearLocalStorageDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteEggGroupDialog" persistent max-width="350">
      <v-card v-if="this.groupToDelete != null" class="pb-2" color="cardbackground">
        <div class="pa-4 text-h6 text-wrap">Delete Archived Egg Group</div>
        <v-card-text>
          {{this.groupToDelete.groupName}}<br />
          {{formatDate(this.groupToDelete.uploadDate)}}<br />
          <br />Are you sure you want to delete this group?
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" class="white--text" @click="deleteEggArchiveGroup()">Yes</v-btn>
          <v-btn color="secondary" outlined @click="deleteEggGroupDialog = null">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteVisionGroupDialog" persistent max-width="350">
      <v-card v-if="this.groupToDelete != null" class="pb-2" color="cardbackground">
        <div class="pa-4 text-h6 text-wrap">Delete Archived Vision Group</div>
        <v-card-text>
          {{this.groupToDelete.groupName}}<br />
          {{formatDate(this.groupToDelete.uploadDate)}}<br />
          <br />Are you sure you want to delete this group?
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" class="white--text" @click="deleteVisionArchiveGroup()">Yes</v-btn>
          <v-btn color="secondary" outlined @click="deleteVisionGroupDialog = null">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="restoreArchivedEggGroupDialog" persistent max-width="350">
      <v-card class="pb-2" color="cardbackground">
        <v-card-title class="text-h5">Restore Egg Group</v-card-title>
        <v-card-text>
          <div v-if="this.groupToRestore != null">
            {{this.groupToRestore.groupName}}<br />
            Collection Date: {{formatDate(this.groupToRestore.date)}}<br />
            Upload Date: {{formatDate(this.groupToRestore.uploadDate)}}<br />
            Delete Date: {{formatDate(this.groupToRestore.deleteDate)}}<br />
            <br />Are you sure you want to restore this group?
          </div>  
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" class="white--text" @click="restoreArchivedEggGroup()">Yes</v-btn>
          <v-btn color="secondary" outlined @click="restoreArchivedEggGroupDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="restoreArchivedVisionGroupDialog" persistent max-width="350">
      <v-card class="pb-2" color="cardbackground">
        <v-card-title class="text-h5">Restore Vision Group</v-card-title>
        <v-card-text>
          <div v-if="this.groupToRestore != null">
            {{this.groupToRestore.groupName}}<br />
            Collection Date: {{formatDate(this.groupToRestore.date)}}<br />
            Upload Date: {{formatDate(this.groupToRestore.uploadDate)}}<br />
            Delete Date: {{formatDate(this.groupToRestore.deleteDate)}}<br />
            <br />Are you sure you want to restore this group?
          </div>  
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" class="white--text" @click="restoreArchivedVisionGroup()">Yes</v-btn>
          <v-btn color="secondary" outlined @click="restoreArchivedVisionGroupDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="viewArchivedEggGroupDialog" persistent max-width="380">
      <v-card v-if="viewArchivedEggGroupDialog" class="pb-2" color="cardbackground">
        <v-card-text class="pa-2">
          <div class="primary--text title pl-2 py-2">{{groupToView?groupToView.groupName:''}}</div>
          <div v-if="viewArchivedGroupDetails">
            <v-simple-table
              class="mx-1"
              v-if="groupToView"
              :fixed-header="true"
              :height="190"
              dense
            >
              <thead>
                <tr>
                  <th class="px-1 caption">Badge</th>
                  <th class="px-1 caption">Wingband</th>
                  <th class="px-1 caption">Grade</th>
                  <th class="px-1 caption">Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in groupToView.samples" :key="item.badge">
                  <td class="px-1 caption">{{item.badge}}</td>
                  <td class="px-1 caption">{{item.wingband}}</td>
                  <td class="px-1 caption">{{item.grade}}</td>
                  <td class="px-1 caption" nowrap>{{item.date}}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
          <div v-else class="pt-0">
            <ul class="font-weight-medium">
              <li><b>Operator:</b> {{ getOperatorNames(groupToView) }}</li>
              <li><b>Farm:</b> {{groupToView?groupToView.farm:''}}</li>
              <li><b>House:</b> {{groupToView?groupToView.house:''}}</li>
              <li><b>Collection Date:</b> {{groupToView?groupToView.date:''}}</li>
              <li><b>Notes:</b> {{groupToView?groupToView.notes:''}}</li>
              <li><b>ClientUid:</b> {{groupToView?groupToView.clientUid:''}}</li>
            </ul>
            <div style="clear: both;"></div>
          </div>
        </v-card-text>
        <v-card-actions v-if="viewArchivedGroupDetails">
          <div class="flex-grow-1"></div>
          <div class="mr-1 caption text-left">Count: {{groupToView?groupToView.samples.length:''}}</div>
          <v-spacer />
          <v-spacer />
          <v-btn color="primary" outlined @click="viewArchivedGroupDetails = false">Summary</v-btn>
          <v-btn color="secondary" outlined @click="viewArchivedEggGroupDialog = false; viewArchivedGroupDetails = false">Close</v-btn>
        </v-card-actions>
        <v-card-actions v-else class="pt-3">
            <div class="flex-grow-1"></div>
              <v-btn color="primary" outlined @click="viewArchivedGroupDetails = true">Details</v-btn>
            <v-btn color="secondary" outlined @click="viewArchivedEggGroupDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="viewArchivedVisionGroupDialog" persistent max-width="380">
      <v-card v-if="viewArchivedVisionGroupDialog" class="pb-2" color="cardbackground">
        <v-card-text class="pa-2">
          <div class="primary--text title pl-2 py-2">{{groupToView?groupToView.groupName:''}}</div>
          <div class="pt-0">
            <ul class="font-weight-medium">
              <li><b>Operator:</b> {{ groupToView?groupToView.operator:'' }}</li>
              <li><b>Farm:</b> {{groupToView?groupToView.farm:''}}</li>
              <li><b>Line:</b> {{groupToView?groupToView.line:''}}</li>
              <li><b>MG:</b> {{groupToView?groupToView.mg:''}}</li>
              <li><b>Collection Date:</b> {{groupToView?groupToView.date:''}}</li>
              <li><b>Notes:</b> {{groupToView?groupToView.notes:''}}</li>
              <li><b>ClientUid:</b> {{groupToView?groupToView.clientUid:''}}</li>
            </ul>
            <div style="clear: both;"></div>
          </div>
        </v-card-text>
        <v-card-actions class="pt-3">
            <div class="flex-grow-1"></div>
            <v-btn color="secondary" outlined @click="viewArchivedVisionGroupDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="restoreArchivedVisionGroupDialog" persistent max-width="350">
      <v-card class="pb-2" color="cardbackground">
        <v-card-title class="text-h5">Restore Vision Group</v-card-title>
        <v-card-text>
          <div v-if="this.groupToRestore != null">
            {{this.groupToRestore.groupName}}<br />
            Collection Date: {{formatDate(this.groupToRestore.date)}}<br />
            Upload Date: {{formatDate(this.groupToRestore.uploadDate)}}<br />
            Delete Date: {{formatDate(this.groupToRestore.deleteDate)}}<br />
            <br />Are you sure you want to restore this group?
          </div>  
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" class="white--text" @click="restoreArchivedVisionGroup()">Yes</v-btn>
          <v-btn color="secondary" outlined @click="restoreArchivedVisionGroupDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDeviceNameDialog" persistent max-width="350">
       <v-card class="pb-2" color="cardbackground">
        <v-card-title class="text-h5">Edit Device Name</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              The <b>Device Name</b> should be unique. It is used to show which device
              the Egg Groups have been uploaded from.
              <v-text-field
                class="mt-1"
                v-model="deviceName"
                clearable
                label="Device name"
                type="text"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" class="white--text" @click="saveDeviceName()">Save</v-btn>
          <v-btn color="secondary" @click="cancelDeviceName()">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="isBusy">
      <v-row>
        <span class="text-h4" color="overlaytext">
          {{ overlayMessage }}
        </span>
      </v-row>
      <v-row>
        <v-progress-linear
          model-value="40"
          color="primary"
          label-position="bottom"
          hide-value
          indeterminate>
        </v-progress-linear>
      </v-row>
    </v-overlay>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import OfflineStorage from '../utils/offlineStorage'
import RealSenseCameraApi from '../api/realSenseCameraApi'

export default {
  //name: 'Metadata',
  components: {
  },
  data() {
    return {
      cameraApi: new RealSenseCameraApi(),
      isBusy: false,
      overlayMessage: '',
      archivedEggGroups: [],
      archivedVisionGroups: [],
      clearLocalStorageDialog: false,
      deleteEggGroupDialog: false,
      deleteVisionGroupDialog: false,
      deviceName: "",
      showDeviceNameDialog: false,
      groupToDelete: null,
      groupToRestore: null,
      groupToView: null,
      panel: 0,
      restoreArchivedEggGroupDialog: false,
      restoreArchivedVisionGroupDialog: false,
      searchEggGroupArchive: '',
      searchVisionGroupArchive: '',
      showGroupDetail: {egg: [], vision: []},
      viewArchivedEggGroupDialog: false,
      viewArchivedVisionGroupDialog: false,
      viewArchivedGroupDetails: false,
    }
  },
  async created() {
    try {
      this.archivedEggGroups = await OfflineStorage.getItem('archivedEggGroups');
      if (this.archivedEggGroups == null) this.archivedEggGroups = [];
      this.archivedVisionGroups = await OfflineStorage.getItem('archivedEggVisionGroups');
      if (this.archivedVisionGroups == null) this.archivedVisionGroups = [];
      this.deviceName = await OfflineStorage.getItem('deviceName');
    } catch(error) {
      this.$root.showNoticeError(error.message);
    }
  },
  computed: {
    ...mapState(['settings', 'isOnline']),
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    filteredArchiveEggGroups() {
      if (this.searchEggGroupArchive == null || this.searchEggGroupArchive.length===0) return this.archivedEggGroups;
      var filteredGroups = this.archivedEggGroups.filter(bs => bs.groupName.includes(this.searchEggGroupArchive.toUpperCase()) 
            || this.formatDate(bs.uploadDate).includes(this.searchEggGroupArchive.toUpperCase())
      );
      return filteredGroups;
    },
    filteredArchiveVisionGroups() {
      if (this.searchVisionGroupArchive == null || this.searchVisionGroupArchive.length===0) return this.archivedVisionGroups;
      var filteredGroups = this.archivedVisionGroups.filter(bs => bs.groupName.includes(this.searchVisionGroupArchive.toUpperCase()) 
            || this.formatDate(bs.uploadDate).includes(this.searchVisionGroupArchive.toUpperCase())
      );
      return filteredGroups;
    }
  },
  methods: {
    confirmClearLocalStorage() {
      if (!this.isOnline) {
        const msg = "Must be on-line to clear Local Storage.";
        this.$root.showNoticeError(msg);
      }
      else this.clearLocalStorageDialog = true;
    },
    confirmDeleteEggGroup(item) {
      this.groupToDelete = item;
      this.deleteEggGroupDialog = true;
    },
    confirmRestoreEggGroup(item) {
      this.groupToRestore = item;
      this.restoreArchivedEggGroupDialog = true;
    },
    confirmDeleteVisionGroup(item) {
      this.groupToDelete = item;
      this.deleteVisionGroupDialog = true;
    },
    confirmRestoreVisionGroup(item) {
      this.groupToRestore = item;
      this.restoreArchivedVisionGroupDialog = true;
    },
    async clearLocalStorage() {
      try {
        if (!this.isOnline) {
          this.clearLocalStorageDialog = false;
          throw new Error("Must be on-line to clear Local Storage.");
        }
        await OfflineStorage.clear();
        window.location = process.env.BASE_URL;
      } catch (error) {
        this.$root.showNoticeError(error.message);
      }
    },
    async saveDeviceName() {
      await OfflineStorage.setItem('deviceName', this.deviceName);
       this.showDeviceNameDialog = false;
    },
    async cancelDeviceName() {
       this.deviceName = await OfflineStorage.getItem('deviceName');
       this.showDeviceNameDialog = false;
    },
    async deleteEggArchiveGroup() {
      const index = this.archivedEggGroups.findIndex(x => x === this.groupToDelete);
      this.archivedEggGroups.splice(index, 1);
      await OfflineStorage.setItem('archivedEggGroups', this.archivedEggGroups);
      this.$root.showNoticeSuccess('Egg Group Deleted Successfully');
      this.deleteEggGroupDialog = false;
      this.groupToDelete = null;
    },
    async deleteVisionArchiveGroup() {
      if(this.isBusy) return;
      this.isBusy = true;
      this.deleteVisionGroupDialog = false;
      const index = this.archivedVisionGroups.findIndex(x => x === this.groupToDelete);
      try {
        for (let tray of this.archivedVisionGroups[index].trays) {
          if (tray.base_file_name1 != null) {
            this.overlayMessage = `Deleting files for ${tray.base_file_name1}`;
            await this.cameraApi.deleteFiles(tray.base_file_name1);
          }
          if (tray.base_file_name2 != null) {
            this.overlayMessage = `Deleting files for ${tray.base_file_name2}`;
            await this.cameraApi.deleteFiles(tray.base_file_name2);
          }
        }
        this.archivedVisionGroups.splice(index, 1);
        await OfflineStorage.setItem('archivedEggVisionGroups', this.archivedVisionGroups);
        this.$root.showNoticeSuccess('Vision Group Deleted Successfully');
      }
      catch(error) {
        this.$root.showNoticeError(`Abording Delete: Error deleting archived vision group files: ${error.message}`);     
      }
      finally{
        this.groupToDelete = null;
        this.isBusy = false;
      }
    },
    formatDate(dt) {
      if (!dt) return null;
      let fdt = new Date(dt).toLocaleString();
      fdt = fdt.replace(',','');
      return fdt;
    },
    getOperatorNames(item) {
      let uniqueOperatorIds = item.samples
        .filter((v,i,a)=>a.findIndex(t=>(t.operatorId === v.operatorId))===i)
        .map(e=>e.operatorId)
      let operatorNames = this.settings.farmOperators
        .filter(o => uniqueOperatorIds.includes(o.operatorId))
        .map(e=>e.operatorName);
      return operatorNames.join(", ");
    },
    isAdmin() {
      if (this.settings.userContext) {
        return this.settings.userContext.contextName == 'ADMIN';
      }
      else return false;
    },
    isManager(farm) {
      if (!this.settings.userContext) return false;
      if (this.settings.userContext.contextName != 'MANAGER') return false;
      if (!farm) return true; // farm context not supplied.
      let farms = this.settings.userContext.contextValue.split(',');
      if (farms.find(f => f == farm)) return true;
      return false;
    },
    async restoreArchivedEggGroup() {
      const index = this.archivedEggGroups.findIndex(x =>x == this.groupToRestore);
      this.archivedEggGroups[index].restoreDate = new Date();

      let eggGroups = await OfflineStorage.getItem('eggGroups');
      if (eggGroups == null) eggGroups = [];
      eggGroups.push(this.archivedEggGroups[index]);
      await OfflineStorage.setItem('eggGroups', eggGroups);

      this.archivedEggGroups.splice(index, 1);
      await OfflineStorage.setItem('archivedEggGroups', this.archivedEggGroups);

      this.$root.showNoticeSuccess('Egg Group Restored Successfully.');

      this.restoreArchivedEggGroupDialog = false;
    },
    async restoreArchivedVisionGroup() {
      const index = this.archivedVisionGroups.findIndex(x =>x == this.groupToRestore);
      this.archivedVisionGroups[index].restoreDate = new Date();

      let visionGroups = await OfflineStorage.getItem('eggVisionGroups');
      if (visionGroups == null) visionGroups = [];
      visionGroups.push(this.archivedVisionGroups[index]);
      await OfflineStorage.setItem('eggVisionGroups', visionGroups);

      this.archivedVisionGroups.splice(index, 1);
      await OfflineStorage.setItem('archivedEggVisionGroups', this.archivedVisionGroups);

      this.$root.showNoticeSuccess('Vision Group Restored Successfully.');

      this.restoreArchivedVisionGroupDialog = false;
    },
    showViewEggDialog(group) {
      this.groupToView = group;
      this.viewArchivedEggGroupDialog = true;
    },
    showViewVisionDialog(group) {
      this.groupToView = group;
      this.viewArchivedVisionGroupDialog = true;
    },
    sortGroupActionDates(group) {
      const actions = [
        {icon:'mdi-upload',date: group.uploadDate},
        {icon:'mdi-file-restore-outline',date: group.restoreDate},
        {icon: 'mdi-delete-outline', date: group.deleteDate}
      ];
      const sortedActions = actions.sort((a,b) => {
        if (a.date == null)
          return -1;
        if (b.date == null)
          return 1;
        else 
          return a.date - b.date;
      });
      return sortedActions;
    },
    toggleGroupDetail(group, index) {
      group[index] = !group[index];
      this.$forceUpdate();
    }
  }
}
</script>